import { formatNumber } from "../../../helpers/number/numberFormat"
import theme from "../../theme"
import { Box } from '../Box'
import { NextButton } from "../Button"
import { Icon } from "../Icon"
import { Image } from "../Image"
import { Text } from "../"
import { openShoppingTab } from '../../../helpers/cretool-extjs/Tabs'
import SeeMoreDetailIcon from '../../../assets/icons/icon_see_more_details.svg'
import { useApp } from "../../../contexts"
import { translateText } from "../../../helpers/util"

export const ShoppingsNearCard = ({ shopping, index }) => {

    const { userCountry, language, translations } = useApp()

    const handleClickImgShopping = (shopping) => {
        openShoppingTab(shopping);
    }

    return (
        <div style={styles.container}>
            <div style={styles.numberContainer}>{index}</div>
            <Box style={styles.contentContainer}>
                <div style={styles.photoContainer}>
                {/* https://d6bmyxfy7viyd.cloudfront.net/${width}x${height}/ */}
                <img src={`https://d6bmyxfy7viyd.cloudfront.net/90x115/${shopping.img_fachada}`} width={'100%'} />

                    {/* <Image url={shopping.img_fachada} fitIn={false} width={90} height={115} /> */}
                </div>
                <Box style={styles.shoppingNameAddressContainer}>
                    <div style={styles.buildingName} onClick={() => handleClickImgShopping(shopping)}>{shopping.nome}</div>
                    <div><Text style={styles.shoppingAddress}>{shopping.endereco}</Text></div>
                    <Box style={styles.shoppingInfo}>
                        <Text>{shopping.total_lojas}  {translateText("Lojas", language, translations, userCountry)}</Text>
                    </Box>
                </Box>
                <div style={styles.seeMoreDetails}>
                    <div style={styles.seeMoreDetailsIcon} onClick={() => handleClickImgShopping(shopping)}>
                        <img src={SeeMoreDetailIcon} width={'100%'} height={'100%'} />
                    </div>
                </div>
            </Box>
        </div>
    )
}

const styles = {
    container: {
        backgroundColor: '#D9D9D9',
        marginLeft: 5,
        marginRight: 5,
        position: 'relative'
    },
    numberContainer: {
        backgroundColor: "#DD2025",
        position: 'absolute',
        width: 20,
        height: 20,
        color: '#FFF',
        borderRadius: 10,
        top: -6,
        left: -4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12,
        zIndex: 1001
    },
    contentContainer: {
        flexDirection: 'row',
        display: 'flex',
        position: 'relative'
    },
    photoContainer: {
        width: 90,
        height: 115,
        zIndex: 0
    },
    shoppingNameAddressContainer: {
        flexDirection: 'column', 
        display: 'flex', 
        flex: 1,
        fontSize: 12,
        minWidth: 230,
        padding: 5
    },
    buildingName: {
        cursor: 'pointer',
        fontWeight: '700'
    },
    shoppingAddress: {
        fontSize: 12, 
        fontWeight: "600", 
        color: "#565656"
    },
    shoppingInfo: { 
        marginTop: 20 
    },
    statsContainer: {
        flexDirection: 'row',
        display: 'flex'
    },
    statsText: {
        fontSize: 14,
        fontWeight: '700',
        marginLeft: 6
    },
    seeMoreDetails: {
        position: 'absolute',
        bottom: 10,
        right: 10
    },
    seeMoreDetailsIcon: {
        width: 22,
        height: 22,
        cursor: 'pointer'
    }
}